import styled from 'styled-components';

export const UiAppBar = styled.div`
	display: block;
`;
